export default __webpack_public_path__ + "static/media/title_pop2_eng.ad43a42e.png";